import react, { useEffect, useState } from "react";
import { colors, fonts } from "../../Styles";

interface ToggleBox_Props {
  text?: string
  isChecked?: boolean
  disabled?: boolean
  onChange: (e:boolean) => void;
  icon: JSX.Element
}

export default function ToggleBox({ text, onChange, disabled, isChecked, icon }:ToggleBox_Props) {
  const [checked, setChecked] = useState(isChecked || false);

  useEffect(() => {
    setChecked(isChecked || false);
  }, [isChecked]);

  const handleClick = () => {
    const newChecked = !checked;
    setChecked(newChecked);
    onChange(newChecked); 
  };

  const _root = text
  ? { display: "flex", flexDirection: "row" as const, alignItems: "center", justifyContent: "start", gap: "10px"}
  : undefined

  return (
    <div style={{..._root }}> 
      <div onClick={handleClick} style={{
        position: "relative",
        width: "50px",
        height: "30px",
        backgroundColor: checked ? colors.systemGreen : colors.greySecondary,
        borderRadius: "15px",
        cursor: disabled ? 'cursor' : 'pointer',
        pointerEvents: disabled ? 'none' : 'auto',
        boxSizing: "border-box"
      }}>
        <div style={{ 
          boxSizing: "border-box", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center", 
          zIndex: "5", 
          transition: "0.5s ease-in-out",
          position: "absolute", 
          top: "50%", 
          left: "0%", 
          transform: checked ? "translate(100%, -50%) rotate(1deg)" : "translate(15%, -50%) rotate(-179deg)", 
          width: "23px", 
          height: "23px", 
          borderRadius: "15px", 
          backgroundColor: colors.greyDarkSecondary, 
        }}>
          {icon}
        </div>

      </div>
      <p style={{...fonts.header, color: colors.greyLightTertiary, ...fonts.fontSize4, cursor: 'cursor'}}>{text}</p>
    </div>
  );
}